import React, { useMemo } from 'react';

const OrderSummary = React.memo(({ 
  items, 
  isTunisianUser, 
  TND_EXCHANGE_RATE, 
  shipping, 
  subtotal, 
  shippingLoading 
}) => {
  // Helper to format currency
  const formatCurrency = useMemo(() => (amount) => {
    if (isTunisianUser) {
      return `${amount.toFixed(2)} TND`;
    } else {
      return `€${amount.toFixed(2)}`;
    }
  }, [isTunisianUser]);

  const displaySubtotal = useMemo(() => 
    isTunisianUser ? (subtotal * TND_EXCHANGE_RATE) : subtotal, 
    [isTunisianUser, subtotal, TND_EXCHANGE_RATE]
  );
  
  const displayTotal = useMemo(() => 
    isTunisianUser ? (subtotal * TND_EXCHANGE_RATE + (shipping || 0)) : (subtotal + (shipping || 0)), 
    [isTunisianUser, subtotal, TND_EXCHANGE_RATE, shipping]
  );

  return (
    <div className="bg-white shadow-md border border-gray-200 rounded-lg p-6 h-fit">
      <h2 className="text-xl font-semibold mb-4">Order Summary</h2>
      <div className="space-y-4">
        {items.map((item) => (
          <div key={item.id + '-' + item.variantIndex} className="flex justify-between items-center">
            <div className="flex items-center gap-3">
              <img
                src={item.image}
                alt={item.title}
                className="w-12 h-12 object-cover rounded"
              />
              <div>
                <p className="font-medium">{item.title} <span className='text-xs text-gray-500 ml-1'>({item.weight})</span></p>
                <p className="text-sm text-gray-500">Qty: {item.quantity}</p>
              </div>
            </div>
            <p className="font-medium">
              {isTunisianUser 
                ? formatCurrency(parseFloat(item.price) * TND_EXCHANGE_RATE * item.quantity) 
                : formatCurrency(parseFloat(item.price) * item.quantity)
              }
            </p>
          </div>
        ))}
        <hr className="my-4" />
        <div className="space-y-2">
          <div className="flex justify-between">
            <span className="text-gray-700">Subtotal</span>
            <span className="font-medium">{formatCurrency(displaySubtotal)}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-700">Shipping</span>
            {shippingLoading ? (
              <span className="text-sm text-gray-500">Loading shipping fee...</span>
            ) : (
              <span className="font-medium">{formatCurrency(shipping || 0)}</span>
            )}
          </div>
          <hr className="my-2" />
          <div className="flex justify-between text-lg font-semibold">
            <span>Total</span>
            <span>{formatCurrency(displayTotal)}</span>
          </div>
        </div>
      </div>
    </div>
  );
});

export default OrderSummary; 